import {
  ClaimPaymentResponseDtoPaymentStatusEnum,
  ClaimPaymentResponseDtoClaimsPaymentSourceEnum,
} from 'libs/pinnacle-sdk';

export interface ClaimsPaymentRow {
  id: number;
  claimPaymentId: string;
  transactionDate: string;
  transactionId: string;
  insured: string;
  binder: string;
  reinsured: string;
  broker: string;
  claimsPaymentSource: ClaimPaymentResponseDtoClaimsPaymentSourceEnum;
  fromBankAccount: string;
  settlementCurrency: string;
  thisPaymentOurShare: string;
  settlementExchangeRate: string;
  paymentStatus: ClaimPaymentResponseDtoPaymentStatusEnum;
}

export const EPaymentStatus = ClaimPaymentResponseDtoPaymentStatusEnum;
export type EPaymentStatus = ClaimPaymentResponseDtoPaymentStatusEnum;

export const EClaimsPaymentSource =
  ClaimPaymentResponseDtoClaimsPaymentSourceEnum;
export type EClaimsPaymentSource =
  ClaimPaymentResponseDtoClaimsPaymentSourceEnum;
